// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
    margin: 10px;
    border-bottom: none;
    text-align: center;
    width: 100%;
}

.loading-gif{
    text-align: center !important; 
    margin: 0 auto !important; 
    display: inline-block !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-components-module/loading/loading.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,gCAAgC;AACpC","sourcesContent":[".loader {\r\n    margin: 10px;\r\n    border-bottom: none;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.loading-gif{\r\n    text-align: center !important; \r\n    margin: 0 auto !important; \r\n    display: inline-block !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
